<div *ngIf="aberta" class="modal-backdrop-custom" (click)="fechar.emit()">
  <div class="modal-card" (click)="$event.stopPropagation()">
    <div class="modal-header-custom">
      <h3 class="h5 mb-0">{{ titulo }}</h3>
      <button type="button" class="btn btn-light btn-sm" (click)="fechar.emit()" aria-label="Fechar">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="modal-body-custom">
      <div class="input-group mb-3">
        <input
          class="form-control"
          [ngModel]="termo"
          (ngModelChange)="termoChange.emit($event)"
          [name]="nomeCampo"
          [placeholder]="placeholder">
        <button
          *ngIf="termo"
          type="button"
          class="btn btn-outline-secondary"
          (click)="limpar.emit()"
          aria-label="Limpar pesquisa">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
      <div class="list-group modal-lista">
        <button
          *ngFor="let item of itens"
          type="button"
          class="list-group-item list-group-item-action"
          (click)="selecionar.emit(item)">
          <div class="fw-semibold">{{ rotuloItem(item) }}</div>
          <div class="small text-secondary">{{ detalheItem(item) }}</div>
        </button>
        <div *ngIf="itens.length === 0" class="text-secondary small">
          {{ mensagemVazia }}
        </div>
      </div>
    </div>
  </div>
</div>
